app.modules.mainMenu = ((self = {}) => {
  const _catalogue = document.querySelector('.js-main-menu__item_catalogue');
  const _rubricsTree = document.querySelector('.js-rubrics-tree');

  function _toggleCatalogueState() {
    _catalogue.classList.toggle('main-menu__item_open');
    _rubricsTree.style.display = _catalogue.classList.contains(
      'main-menu__item_open'
    )
      ? 'flex'
      : 'none';
  }

  function _addListeners() {
    if (_catalogue) {
      _catalogue.addEventListener('click', _toggleCatalogueState);
    }
  }

  self.load = _addListeners;
  return self;
})(app.modules.mainMenu);
